import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { CardSkeleton } from '@/components/ui/Skeleton'
import { useStoreGate } from '@/contexts/StoreGateContext'
import {
  resolveStorePageLoader,
  StorePageLoader,
} from '@/store/components/StorePageLoader'
import { AdminRoutes } from './adminRoutes'
import { StoreRoutes } from './storeRoutes'

function AdminPageLoader() {
  return (
    <div className="space-y-4 p-6">
      <CardSkeleton />
      <CardSkeleton />
    </div>
  )
}

export function AppRoutes() {
  const { status } = useStoreGate()
  const { pathname } = useLocation()

  if (status === 'loading') {
    if (resolveStorePageLoader(pathname)) {
      return <StorePageLoader />
    }
    return <AdminPageLoader />
  }

  return (
    <Routes>
      {StoreRoutes()}
      {AdminRoutes()}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
